import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountsService } from '../accounts.service';
import { map } from 'rxjs/operators';
import { UpgradeCTADialogComponent } from '@vendasta/uikit';
import { MatDialogRef } from '@angular/material/dialog';
import { UpgradeCTADialogService } from '../core/get-pro/pro-upgrade-cta.service';

@Injectable()
export class UpgradeCTAGuard {
  upgradeCTADialog: MatDialogRef<UpgradeCTADialogComponent>;
  constructor(
    private accountsService: AccountsService,
    private router: Router,
    private upgradeCTAService: UpgradeCTADialogService,
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.accountsService.isExpress$.pipe(
      map((isExpress: boolean) => {
        if (!!isExpress && !this.upgradeCTADialog) {
          this.upgradeCTADialog = this.upgradeCTAService.openUpgradeModel();
          this.upgradeCTADialog.afterClosed().subscribe((result) => {
            this.upgradeCTADialog = null;
            if (result) {
              this.upgradeCTAService.businessCenterUpgrade();
            }
          });
        }
        return !isExpress;
      }),
    );
  }
}
